const FILTERS = [
  ["all", "All", () => true],
  ["running", "Running", (k, busy) => busy(k)],
  ["review", "Needs a look", (k, busy) => !busy(k) && k.status === "review" && !k.ready && !k.product?.published],
  ["ready", "Ready", (k) => k.ready && !k.product?.published],
  ["live", "Live", (k) => !!k.product?.published],
];

export const applyFilter = (list, id, busy) => list.filter((k) => (FILTERS.find((f) => f[0] === id) || FILTERS[0])[2](k, busy));

export const KitFilters = ({ list, value, onChange, busy }) => (
  <div data-testid="kit-filters" className="flex flex-wrap gap-2 mb-5">
    {FILTERS.map(([id, label, fn]) => {
      const n = list.filter((k) => fn(k, busy)).length;
      const on = value === id;
      return (
        <button key={id} data-testid={`kit-filter-${id}`} onClick={() => onChange(id)} aria-pressed={on}
          className={`rounded-full px-4 py-1.5 text-sm border transition-colors ${on ? "bg-[#2B2A26] text-white border-[#2B2A26]" : "bg-white text-stone-700 border-stone-300 hover:border-stone-500"}`}>
          {label} <span className={`ml-1 font-mono-ui text-xs ${on ? "text-white/70" : "text-stone-400"}`}>{n}</span>
        </button>
      );
    })}
  </div>
);
